import styled from "styled-components";

export const Page = styled.main`
	min-height: 100vh;
	background: #fff;
	color: #4b5a70;
	font-family: "Inter", sans-serif;
`;
export const Container = styled.section`
	width: min(1220px, 100%);
	min-height: 100vh;
	margin: 0 auto;
	padding: 58px 0 0px;
	background: #fff;
	position: relative;
	display: flex;
	flex-direction: column;
	@media (min-width: 671px) {
		padding-top: 75px;
	}
	@media (max-width: 670px) {
		width: 100%;
		padding-top: 58px;
	}
`;
export const Header = styled.header`
	width: min(1090px, calc(100% - 32px));
	height: 70px;
	position: absolute;
	top: 23px;
	left: 50%;
	transform: translateX(-50%);
	padding: 0 37px;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	z-index: 2;
	@media (max-width: 670px) {
		width: calc(100% - 24px);
		height: auto;
		min-height: 70px;
		padding: 14px 16px;
		flex-wrap: wrap;
		row-gap: 10px;
		justify-content: space-between;
	}
	@media (min-width: 671px) {
		top: 40px;
		height: 88px;
		padding-left: 48px;
		padding-right: 48px;
	}
	@media (min-width: 671px) and (max-width: 1024px) {
		width: calc(100% - 32px);
		padding-left: 24px;
		padding-right: 24px;
	}
`;
export const Logo = styled.img`
	width: 91px;
	height: auto;
	@media (min-width: 671px) {
		width: 112px;
	}
`;
export const HeaderActions = styled.div`
	display: flex;
	align-items: center;
	gap: 30px;
	@media (max-width: 670px) {
		width: auto;
		flex: 0 1 auto;
		margin-left: auto;
		gap: 10px;
		justify-content: flex-end;
	}
	@media (min-width: 671px) {
		gap: 24px;
	}
`;
export const BackButton = styled.button`
	border: 0;
	color: #4b5a70;
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 600;
	font-style: normal;
	line-height: 100%;
	letter-spacing: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	white-space: nowrap;
	@media (min-width: 671px) {
		width: 95px;
		justify-content: flex-start;
		padding-left: 12px;
	}
`;
export const PreviousArrow = styled.img`
	object-fit: contain;
`;
export const AccessText = styled.span`
	color: #4b5a70;
	font-family: "Inter", sans-serif;
	font-size: 12px;
	font-weight: 400;
	font-style: normal;
	line-height: 100%;
	letter-spacing: 0;
	@media (max-width: 670px) {
		max-width: 145px;
		text-align: right;
	}
`;
export const Content = styled.section`
	height: auto;
	flex: 0 0 auto;
	min-height: 802px;
	padding: 91px 65px 50px 65px;
	background: #e4e7eb;
	@media (max-width: 670px) {
		height: auto;
		min-height: 802px;
		flex: 1 0 auto;
		padding: 91px 16px 40px;
	}
	@media (min-width: 671px) {
		padding-top: 91px;
	}
	@media (min-width: 671px) and (max-width: 1024px) {
		padding-left: 40px;
		padding-right: 40px;
	}
`;
export const SectionHeadingRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	@media (max-width: 670px) {
		flex-direction: column;
		align-items: flex-start;
	}
`;
export const SectionTitle = styled.h2`
	margin: 0 0 20px;
	color: #4a5565;
	font-family: "Inter", sans-serif;
	font-size: 20px;
	font-weight: 700;
	font-style: normal;
	line-height: 100%;
	letter-spacing: 0;
`;
export const InfoSectionTitle = styled(SectionTitle)`
	margin-top: 26px;
	margin-bottom: 26px;
`;
export const AddButton = styled.button`
	min-width: 202px;
	height: 40px;
	margin-bottom: 26px;
	padding: 0 0px;
	border: 0;
	background: #008bd2;
	color: #f9fafb;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 14px;
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 600;
	font-style: normal;
	line-height: 100%;
	letter-spacing: 0;
`;
export const PlusIcon = styled.img`
	object-fit: contain;
`;
export const DeliveryCard = styled.div`
	min-height: 91px;
	margin-bottom: 0;
	padding: 18px 72px 18px 24px;
	background: #fff;
	display: grid;
	align-items: center;
	grid-template-columns: 1fr 1fr 1fr 1.35fr 1.6fr 1.6fr;
	gap: 20px;
	@media (min-width: 671px) {
		grid-template-columns:
			minmax(110px, 1.1fr)
			minmax(80px, 0.9fr)
			minmax(70px, 0.8fr)
			minmax(150px, 1.4fr)
			minmax(180px, 1.7fr)
			minmax(220px, 2fr);
		column-gap: 24px;
	}
	@media (min-width: 671px) and (max-width: 1024px) {
		grid-template-columns: repeat(3, minmax(0, 1fr));
		column-gap: 24px;
		row-gap: 18px;
		padding: 18px 20px;
	}
	@media (max-width: 670px) {
		padding-right: 56px;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 18px 14px;
	}
`;
export const DeliveryItem = styled.div`
	display: flex;
	flex-direction: column;
	align-self: start;
	gap: 8px;
	min-width: 0;
	color: #596578;
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 400;
	font-style: normal;
	line-height: 100%;
	letter-spacing: 0;
	span {
		white-space: normal;
		overflow: visible;
		text-overflow: clip;
		overflow-wrap: anywhere;
		line-height: 1.25;
	}
	strong {
		white-space: nowrap;
		color: #26364c;
		font-family: "Inter", sans-serif;
		font-size: 14px;
		font-weight: 600;
		font-style: normal;
		line-height: 100%;
		letter-spacing: 0;
	}
`;
export const FormCard = styled.form`
	margin-top: 18px;
	padding: 32px;
	background: #fff;
	@media (min-width: 671px) and (max-width: 1024px) {
		padding: 24px;
	}
`;
export const FieldGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 505px));
	gap: 12px;
	@media (min-width: 671px) {
		column-gap: 16px;
		row-gap: 10px;
	}
	@media (min-width: 671px) and (max-width: 1024px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
		column-gap: 14px;
	}
	@media (max-width: 670px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 16px 12px;
	}
`;
export const Field = styled.div<{ full?: boolean }>`
	grid-column: ${({ full }) => (full ? "1 / -1" : "auto")};
	display: flex;
	flex-direction: column;
	gap: 8px;
	label {
		color: #26364c;
		font-family: "Inter", sans-serif;
		font-size: 14px;
		font-weight: 600;
		font-style: normal;
		line-height: 100%;
		letter-spacing: 0;
	}
	& > input,
	& > select {
		width: ${({ full }) => (full ? "100%" : "505px")};
		max-width: 100%;
	}
	@media (min-width: 671px) and (max-width: 1024px) {
		& > input,
		& > select {
			width: 100%;
		}
	}
`;
export const FieldError = styled.span`
	margin-top: -2px;
	color: #c62828;
	font:
		400 12px/140% "Inter",
		sans-serif;
`;
export const Input = styled.input`
	width: 505px;
	max-width: 100%;
	height: 40px;
	border: 1px solid #d3d9e1;
	border-radius: 3px;
	padding: 0 10px;
	color: #596578;
	font:
		400 11px "Inter",
		sans-serif;
	&[aria-invalid="true"] {
		border-color: #c62828;
	}
`;
export const Select = styled.select`
	width: 505px;
	max-width: 100%;
	height: 40px;
	border: 1px solid #d3d9e1;
	border-radius: 3px;
	padding: 0 10px;
	background: #fff;
	color: #7a8595;
	font:
		400 11px "Inter",
		sans-serif;
	&[aria-invalid="true"] {
		border-color: #c62828;
	}
`;
export const Actions = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 26px;
	padding: 26px 0 22px;
	@media (max-width: 670px) {
		justify-content: center;
		flex-wrap: wrap;
	}
`;
export const CancelButton = styled.button`
	width: 112px;
	min-width: 112px;
	height: 42px;
	min-height: 42px;
	border: 1px solid #4b5665;
	background: transparent;
	color: #26364c;
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 600;
	font-style: normal;
	line-height: 100%;
	letter-spacing: 0;
	@media (min-width: 671px) {
		width: 113px;
		min-width: 113px;
	}
	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`;
export const PrimaryButton = styled.button`
	width: 160px;
	min-width: 160px;
	height: 42px;
	min-height: 42px;
	padding: 0 17px;
	border: 0;
	background: #008bd2;
	color: #fff;
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 600;
	font-style: normal;
	line-height: 100%;
	letter-spacing: 0;
	&:disabled {
		opacity: 0.7;
		cursor: wait;
	}
`;
export const LoadingSpinner = styled.span`
	display: inline-block;
	width: 14px;
	height: 14px;
	margin-right: 8px;
	border: 2px solid rgba(255, 255, 255, 0.45);
	border-top-color: #fff;
	border-radius: 50%;
	vertical-align: -2px;
	animation: agendamento-fob-spin 0.7s linear infinite;

	@keyframes agendamento-fob-spin {
		to {
			transform: rotate(360deg);
		}
	}
`;
export const Footer = styled.footer`
	width: min(1220px, 100%);
	height: 45px;
	margin: 0 auto;
	padding: 22px 25px 0;
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	color: #526176;
	font-size: 8px;
	img {
		width: auto;
		height: auto;
		opacity: 0.75;
	}
	@media (max-width: 670px) {
		padding-left: 16px;
		padding-right: 16px;
	}
	@media (min-width: 671px) {
		height: 85px;
		padding: 32px 32px 0;
	}
`;
export const ModalOverlay = styled.div`
	position: fixed;
	inset: 0;
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px;
	background: rgba(38, 54, 76, 0.42);
`;
export const Modal = styled.div`
	width: min(460px, 100%);
	padding: 28px;
	background: #fff;
	box-shadow: 0 12px 32px rgba(38, 54, 76, 0.2);
`;
export const ModalTitle = styled.h3`
	margin: 0;
	color: #4a5565;
	font:
		700 20px/100% "Inter",
		sans-serif;
`;
export const ModalDescription = styled.p`
	margin: 12px 0 24px;
	color: #596578;
	font:
		400 14px/140% "Inter",
		sans-serif;
`;
export const ModalForm = styled.form`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;
export const ModalLabel = styled.label`
	color: #26364c;
	font:
		600 14px/100% "Inter",
		sans-serif;
`;
export const ModalInput = styled.input`
	width: 100%;
	height: 40px;
	border: 1px solid #d3d9e1;
	border-radius: 3px;
	padding: 0 10px;
	color: #596578;
	font:
		400 14px/100% "Inter",
		sans-serif;
	&[aria-invalid="true"] {
		border-color: #c62828;
	}
`;
export const ModalActions = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	margin-top: 20px;
`;
export const ModalCancel = styled.button`
	min-width: 112px;
	height: 42px;
	border: 1px solid #4b5665;
	background: transparent;
	color: #26364c;
	font:
		600 14px/100% "Inter",
		sans-serif;
`;
export const ModalSubmit = styled.button`
	min-width: 160px;
	height: 42px;
	border: 0;
	background: #008bd2;
	color: #f9fafb;
	font:
		600 14px/100% "Inter",
		sans-serif;
	&:disabled {
		opacity: 0.7;
		cursor: wait;
	}
`;
export const EmptyState = styled.div`
	min-height: 100vh;
	display: grid;
	place-content: center;
	justify-items: center;
	gap: 20px;
	color: #4b5a70;
	p {
		margin: 0;
		font-size: 14px;
	}
`;
